// extracted by mini-css-extract-plugin
export default {"page-wrapper":"vCDf2WVQYytZEPm0c9VO","title-section":"WFnIHTrm1RnC24rtV5Zs","page-bottom-section":"PKwN0qbwyfeAjZHyszSi","control-section":"_7VEH7kAVgkS6xRmuMz3"};